<div class="d-flex flex-column align-items-center mt-n2">
  <button
    nbButton
    class="mb-1 px-2"
    *ngIf="workoutMode == WorkoutMode.Complete"
    (click)="redoWorkout()"
  >
    <i class="fa fa-redo mr-1"></i>
    Redo Workout?
  </button>
  <button
    nbButton
    class="mb-1 px-2"
    *ngIf="workout && workoutMode !== WorkoutMode.Complete"
    (click)="stopWorkout()"
  >
    <i class="fa fa-ban mr-1"></i>
    End workout
  </button>
  <button
    nbButton
    [nbSpinner]="pending"
    style="padding-top: 1.5rem !important;padding-bottom: 1.5rem !important;padding-left: 1.5rem !important;padding-right: 1.5rem !important; height: 25px !important;"
    class="btn-circle btn-xl btn-alternate workout-btn" 
    (click)="onStartWorkoutClicked()"
    [disabled]="workoutMode == WorkoutMode.Complete"
  >
    <!-- <i class="fa fa-lg fa-play-circle mx-1 start"></i> -->
    <div *ngIf="workoutMode == WorkoutMode.Start">Start Workout</div>
    <div *ngIf="workoutMode == WorkoutMode.Complete">Completed</div>
    <i
      *ngIf="workoutMode == WorkoutMode.Workout"
      class="fa fa-2x fa-pause-circle mx-1"
    ></i>
    <i
      *ngIf="workoutMode == WorkoutMode.Pause"
      class="fa fa-2x fa-play-circle mx-1 start"
    ></i>
    <div *ngIf="workoutMode == WorkoutMode.Pause || workoutMode == WorkoutMode.Workout" class="px-2">
      {{workoutMode == WorkoutMode.Pause? 'Start': 'Pause'}} Workout <br />
      {{ currentExercise }} - <i class="fa fa-clock"></i> {{ timeStringDuration }}
    </div>
  </button>
</div>

<ng-template #completeDlg let-data let-ref="dialogRef">
  <nb-card>
    <nb-card-header>
      <div class="title">
        <span>Completed!</span>
      </div>
    </nb-card-header>

    <nb-card-body class="p-3"> Workout is completed! </nb-card-body>

    <nb-card-footer class="p-1">
      <div class="actions justify-content-center">
        <button
          i18n="@@Ok"
          nbButton
          class="btn-circle btn-xl btn-main btn-main"
          type="submit"
          
          style="width: 60px"
          (click)="ref.close()"
        >
          Ok
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>
